export default "__VITE_ASSET__Ds5oe1hG__"